import { useState } from "react";
import { Link } from "react-router-dom";

const TABS = [
  {
    title: "Stratejik Yönlendirme",
    desc: "VİP Reklam Dekorasyon, sektördeki köklü deneyimi ve uzman kadrosuyla her projeye özgün bir yaklaşım sunmaktadır. Markanızın görünürlüğünü artıracak çözümler üretirken hem estetik hem de işlevselliği ön planda tutuyoruz.",
  },
  {
    title: "Profesyonel Hizmetlerimiz",
    desc: "Cephe kaplama, kutu harf tabela, totem tabela, cafe & restoran dekorasyonu, ışıklı menü board ve anahtar teslim proje hizmetlerimizle sektörün her alanında profesyonel çözümler sunuyoruz.",
  },
  {
    title: "Sürdürülebilir Başarı",
    desc: "Uzun ömürlü malzemeler ve kaliteli işçilikle projelerinizin yıllar boyunca değerini korumasını sağlıyoruz. Bakım ve onarım hizmetlerimizle her zaman yanınızdayız.",
  },
  {
    title: "Sonuç",
    desc: "2004'ten bu yana 1.620'den fazla projede edindiğimiz deneyim ve müşteri memnuniyeti odaklı çalışma anlayışımızla her zaman en iyi sonucu elde ediyoruz.",
  },
];

const FEATURES = [
  { icon: "ri-shield-check-line", label: "Her projede malzeme ve işçilik garantisi" },
  { icon: "ri-time-line", label: "Söz verilen teslim tarihine tam uyum" },
  { icon: "ri-customer-service-2-line", label: "Montaj sonrası ücretsiz teknik destek" },
  { icon: "ri-award-line", label: "20 yılın birikimi ve güven belgesi" },
  { icon: "ri-leaf-line", label: "Enerji tasarruflu, çevre dostu LED sistemler" },
];

const AboutSection = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <section className="py-28 bg-[#181614]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-center gap-3 mb-4 anim-up">
          <div className="w-8 h-[3px] bg-[#E6A800]" />
          <span className="font-head text-[#E6A800] text-xs font-700 uppercase tracking-[0.2em]">
            Neden Biz: VİP Reklam Dekorasyon'un Farkı
          </span>
        </div>
        <h2 className="font-head font-black uppercase text-white text-5xl md:text-6xl leading-[0.9] mb-16 anim-up d1">
          Osmaniye'nin
          <br />
          <span className="text-[#E6A800]">Tabela</span> Uzmanı
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Image */}
          <div className="relative anim-left">
            <div className="relative img-zoom">
              <img
                alt="VİP Reklam - Neden Biz"
                className="w-full object-cover object-top"
                src="/images/neden-vip-reklam-806d6601.jpg"
              />
              <div className="absolute top-0 right-0 w-16 h-1 bg-[#E6A800]" />
              <div className="absolute top-0 right-0 w-1 h-16 bg-[#E6A800]" />
              <div className="absolute bottom-0 left-0 w-16 h-1 bg-[#E6A800]" />
              <div className="absolute bottom-0 left-0 w-1 h-16 bg-[#E6A800]" />
            </div>
            <div className="absolute -bottom-6 right-0 bg-[#E6A800] p-6 anim-float">
              <div className="font-head font-black text-white text-6xl leading-none">20+</div>
              <div className="text-white/70 text-xs font-head font-600 uppercase tracking-widest mt-1">
                Yıllık Deneyim
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="anim-right d2">
            <p className="text-[#B0B0B0] text-sm leading-relaxed mb-4">
              VİP Reklam Dekorasyon, müşteri memnuniyetini ön planda tutarak
              yenilikçi tasarım ve kaliteli malzeme kullanımıyla sektörde öne
              çıkmaktadır.
            </p>
            <p className="text-[#B0B0B0] text-sm leading-relaxed mb-8">
              2004 yılından bu yana Osmaniye'de reklam tabelası, cephe kaplama,
              LED sistemleri ve iç mekan dekorasyonunda 1.620'den fazla projede
              güvenilir çözümler sunmaktayız.
            </p>

            {/* Tabs */}
            <div className="space-y-3 mb-8">
              {TABS.map((tab, i) => (
                <button
                  key={i}
                  onClick={() => setActiveTab(i)}
                  className={`w-full text-left p-4 border tr cursor-pointer ${
                    activeTab === i
                      ? "border-[#E6A800] bg-[#E6A800]/10"
                      : "border-white/10 bg-white/3 hover:border-white/25"
                  }`}
                >
                  <div className="flex items-center gap-2 mb-1">
                    <div
                      className={`w-1.5 h-1.5 tr ${
                        activeTab === i ? "bg-[#E6A800]" : "bg-white/20"
                      }`}
                    />
                    <span
                      className={`font-head font-700 uppercase text-sm tracking-wide tr ${
                        activeTab === i ? "text-[#E6A800]" : "text-white/70"
                      }`}
                    >
                      {tab.title}
                    </span>
                  </div>
                  {activeTab === i && (
                    <p className="text-[#B0B0B0] text-xs leading-relaxed pl-3.5 mt-2">
                      {tab.desc}
                    </p>
                  )}
                </button>
              ))}
            </div>

            {/* Features */}
            <ul className="space-y-3 mb-10">
              {FEATURES.map((f) => (
                <li key={f.label} className="flex items-center gap-3">
                  <div className="w-7 h-7 flex items-center justify-center bg-[#E6A800]/15 shrink-0">
                    <i className={`${f.icon} text-[#E6A800] text-xs`} />
                  </div>
                  <span className="text-[#C4C4C4] text-sm">{f.label}</span>
                </li>
              ))}
            </ul>

            <div className="flex items-center gap-4">
              <Link
                to="/hakkimizda"
                className="inline-flex items-center gap-2 px-6 py-3.5 bg-[#E6A800] text-white hover:bg-[#C99500] tr font-head font-700 uppercase tracking-wider text-sm cursor-pointer whitespace-nowrap"
              >
                Daha Fazla
                <i className="ri-arrow-right-line text-sm" />
              </Link>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 flex items-center justify-center bg-[#E6A800]/20 anim-pulse-ring">
                  <i className="ri-vip-crown-line text-[#E6A800] text-sm" />
                </div>
                <div>
                  <div className="text-white text-xs font-semibold">
                    Veysel Yaylacı
                  </div>
                  <div className="text-[#737373] text-xs">
                    Kurucu &amp; Genel Müdür
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;